import { render, staticRenderFns } from "./userscorerecordlist.vue?vue&type=template&id=7529d2b0&scoped=true"
import script from "./userscorerecordlist.vue?vue&type=script&lang=js"
export * from "./userscorerecordlist.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7529d2b0",
  null
  
)

export default component.exports